import { z } from 'zod'

/** Niveaux alignés sur `UrgentLevel` (cse/UrgentBanner). */
export const urgentLevelSchema = z.enum(['info', 'warning', 'error'])

export const urgentMessageSchema = z.object({
  id: z.string(),
  level: urgentLevelSchema,
  title: z.string().nullable().optional(),
  message: z.string(),
  dismissible: z.boolean(),
})

export const urgentMessagesResponseSchema = z.object({
  data: z.object({
    items: z.array(urgentMessageSchema),
  }),
})

export type UrgentMessage = z.infer<typeof urgentMessageSchema>
